import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiSlider {
    constructor() {

    }

    createSlider() {
    }

    setSliderRange() {
    }

    setSliderValue() {
    }

    sliderValue() {
    }
}
